import React from 'react'
import PropTypes from 'prop-types'
import StepperActionBar from '../StepperActionBar'
import { injectProps } from 'helpers/utils'
import { SectionWrapper, ErrorMessage, ActionBarWrapper } from '../common'

const StoreLocationSelector = ({ children, currentStepIndex, error, submitFailed, onPrevPage, handleSubmit }) =>
  <form onSubmit={ handleSubmit }>
    <SectionWrapper>
      { injectProps(children, { fiveStepper: true }) }
      <ActionBarWrapper>
        <StepperActionBar
          hasPrevPage
          hasNextPage
          isPrevPageVisible
          currentStepIndex={ currentStepIndex }
          prevPageClick={ onPrevPage } />

        <ErrorMessage
          role="alert"
          aria-live="assertive"
          aria-label={ error }>
          { (submitFailed && error) || '' }
        </ErrorMessage>
      </ActionBarWrapper>
    </SectionWrapper>
  </form>

StoreLocationSelector.propTypes = {
  children: PropTypes.element,
  currentStepIndex: PropTypes.number,
  error: PropTypes.string,
  handleSubmit: PropTypes.func,
  onPrevPage: PropTypes.func,
  submitFailed: PropTypes.bool
}

export default StoreLocationSelector
